import { render, staticRenderFns } from "./attributesGrid.vue?vue&type=template&id=0d0b7d96"
import script from "./attributesGrid.vue?vue&type=script&lang=js"
export * from "./attributesGrid.vue?vue&type=script&lang=js"
import style0 from "./attributesGrid.vue?vue&type=style&index=0&id=0d0b7d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports